import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { listViewStore, } from 'owa-mail-list-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { mailSearchStore as searchStoreV2 } from 'owa-mail-search';
import { searchStore as searchStoreV1 } from 'owa-mail-search-store';
import { PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID, ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID, } from 'owa-folders';
export default function shouldShowFolderTag(tableQuery, tableViewId) {
    var searchStore = isMailFeatureEnabled('sea-commonSearchBox') ? searchStoreV2 : searchStoreV1;
    var tableView = listViewStore.tableViews.get(tableViewId);
    if (tableView.tableQuery.type === 1 /* Search */) {
        var tableQuery_1 = tableView.tableQuery;
        return (tableQuery_1.scenarioType !== 'persona' &&
            searchStore.staticSearchScope &&
            ((searchStore.staticSearchScope.kind == "PrimaryMailbox" /* PrimaryMailbox */ &&
                searchStore.staticSearchScope.folderId ===
                    folderNameToId(PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID)) ||
                (searchStore.staticSearchScope.kind == "ArchiveMailbox" /* ArchiveMailbox */ &&
                    searchStore.staticSearchScope.folderId ===
                        folderNameToId(ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID))));
    }
    else if (tableView.tableQuery.type === 0 /* Folder */) {
        var tableQuery_2 = tableView.tableQuery;
        return tableQuery_2.scenarioType === 'persona' || tableQuery_2.viewFilter === 'UserCategory';
    }
    else {
        return false;
    }
}
//# sourceMappingURL=shouldShowFolderTag.js.map